/**
 * 最后修改时间:2020年3月31日08:22:36
 * 14个公司现在在售的产品
 */
let pros = [
  {
    imgPath: require("@/assets/productions/OGMA-PAS.jpg"),
    introName: "OGMA-PAS系列",
    introSubName: "油中溶解气体及微水在线监测装置<br />（光声光谱）",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000377&idx=1&sn=b23e65dbb1f52a326921fb7c31a66319&chksm=7941a2124e362b04a415c17331787384848c80f86a55b925d575ccf4c17ef494975b57840b29&scene=18&xtrack=1&key=e7e5f1c3668833f9adb6f93521e12244ef16bce21525d2761379ffee7683548525cbdbd08e4451927bd0736f92cd875edd6eaf8d10ede2b7b9e34503eb2db0bb64ef83bc9c87c8a3006377d513e742f4&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=Adsd5iqK5DBUD7NxzZOBR%2FA%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/OGMA-3690.jpg"),
    introName: "OGMA-3690系列",
    introSubName: "油中溶解气体及微水在线监测装置<br />（自产载气色谱法）",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000377&idx=2&sn=f5cabac130a7bf6cd51ebd1e61367ca0&chksm=7941a2124e362b04b4e82fe0ace8f62a62a3a1166ae09214877074566e6e1bddc0ff76bc8a45&scene=18&xtrack=1&key=f634041ead6d033177be2783d482f258a058f15bed9fe799a665a86ce3726ce7171e22bc75e50b5807a4256e826860de54cd8ec0b5f7530e54c43656473f1f7a80801f50d71b5cff6f9a636c7cc1f5c7&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=AaSnm4ug4KwnNfo%2FrOG%2FTD4%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/OGMA-2000.jpg"),
    introName: "OGMA-2000系列",
    introSubName: "油中溶解气体及微水在线监测装置<br />（壁挂式）",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000377&idx=3&sn=56a83d515d5574d35933b469941e9733&chksm=7941a2124e362b04020d70ed16f96868141ff32848fabbbda3a2cb7ce4f19da66a3d34b45e94&scene=18&xtrack=1&key=cf63f0cc499df801201b541fe0e674c720bd05e6f9ab3a19105d589c0e60430a19a986a3853cb1ce73d01af6c466c4895d8447fa94c05dfece16d38c7874e2bd6e98477cdba9bb5f0761580327ab8824&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=Ab8ySBFrMEkTsnhmgNzkesI%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/SY-FFTM.jpg"),
    introName: "SY-FFTM",
    introSubName: "光纤测温装置<br />（预埋式）",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000378&idx=1&sn=9a3deb40221ddb5ee0b61e474610b952&chksm=7941a2114e362b07df1b18a923b9d3c4fd32772bb4fd22ca249a4169d07620132278ff2a4328&scene=18&xtrack=1&key=5dab17bee8c24fce2605422a53e5c3e83ffa9988886115c8db0941b936b277b948ae140308e026ee2dc4ad8d662dba242449c5df46035747ee9354112e08f205a26f43e079f8003cf1b5feb04ff4c010&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=AQrr79TANuR30GKLc0rjs0U%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/SY-FFT.jpg"),
    introName: "SY-FFT系列",
    introSubName: "光纤温控器<br />（外置式）",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000378&idx=2&sn=c9fb0e3b8879c44c77c0114eecc809ba&chksm=7941a2114e362b074694372db8b217da1dbc3437cebe004dfa16d904a867ccaab34305120a7f&scene=18&xtrack=1&key=e7e5f1c3668833f9a3069621c1a4597fd11a3ab300cc80c6795adba63764a07e50ed1214ca48eeda87f6a411977111d9ef827c0a9b0477e5da13e56d097a1719987d3143189d0c1f2abe91d2e8a8c8a8&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=ARsWLj8dkjJ3Vts9b5EKK8c%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/SY-FFT-G.jpg"),
    introName: "SY-FFT-G系列",
    introSubName: "光纤温控器<br />（干变式）",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000378&idx=3&sn=f91c162bc270b269254dd98502b78869&chksm=7941a2114e362b072bf0462f1caed7cde64a8c367b4af5a845604c5deb5e14796966652b3aae&scene=18&xtrack=1&key=1ddca6f17e1bf67a7621597333a9c06663b87fa018a2be9afe0fb379be0fc8cb4af06f2071d33c356bec12a4d066bc2c6db5825a1d7825b615af615b957f78e59a755265cb531dcc3772815fb857288a&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=ARbwaVRBLZtWgf6DXrx14ZM%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/BTA.jpg"),
    introName: "SY-BTA系列",
    introSubName: "变压器铁芯接地电流<br />在线监测装置",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000377&idx=4&sn=517ff666cadf0678f567c89cf62c7999&chksm=7941a2124e362b04e9480c20dff763ec06f7ace286a67eb083d0701c8c18946700be0a595cbc&scene=18&xtrack=1&key=6ac3b46b266ce08c3765f2661227dc055f5056824ad21c81cb69241f4bcf5a7332cc35bb702f92e91b8009ef075a0dce29463b686f93940f04f7033fa6305c16fa09aced63736d633560ac91387c610d&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=AbYcAUHxNrDCOsLIEO3MBvY%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/SY-MOA.jpg"),
    introName: "SY-MOA系列",
    introSubName: "避雷器<br />在线监测系统",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000377&idx=5&sn=ad0bfc6ed48005871bc93f2bad1495bb&chksm=7941a2124e362b04d835bd88ffaf0634e14a4abc7d4bc42cfda7788a7dcc94d8d1e518da971b&scene=18&xtrack=1&key=1ddca6f17e1bf67afa686fa4d77f6c8dcded8928bc8ec32f3d069a064f649a0eacd6ca65d424a9e7e9b078c0bdb0b5cddbd44898226ab90a80713329c183201fba9d026bd3dc516467a3a42b62635e93&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=AZlkVF3MKe7%2FO1jG2An2f%2Bk%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/PDOM-0804.jpg"),
    introName: "PDOM系列",
    introSubName: "局部放电<br />在线监测系统",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000377&idx=6&sn=b8349a3b2e026d7f28bddeb3583d707b&chksm=7941a2124e362b0442e22e6e436e14008feeb7bffb31f2a27b604a29132193c019345cb3f089&scene=18&xtrack=1&key=cf63f0cc499df801597b874b7ac9ccb4404248774f4e2713890c5e726c2a73ff7678e1d8207c8f51fc54b3267894c7ab87a34489660d013d04c561523130754ce80282f05e942d203443a75187f82c7a&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=AaZg3COVGliELvjKNpMvZAE%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/BWR2-04.jpg"),
    introName: "BWR2-04口（TH）系列",
    introSubName: "变压器<br />绕组温控器",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000380&idx=1&sn=227baacd2f662e701c04fde761d10240&chksm=7941a2174e362b01372bd7c20fc1e1753793874b085c3ccff24aadd1fb78cdb6df6f53202e3a&scene=18&xtrack=1&key=6ac3b46b266ce08c123a6763bde3a4b68018d2662f7ba6dcf1bdc342efb292506ca3f6dbcfd430ead1b8248725a6e3053414b2fcde8f52916426d8e7665e8392a4e470d53677dad672858b337c7fc697&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=Afa1orvhj8Uu0wWm4cANTkM%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/BWY2-804.jpg"),
    introName: "BWY2 -804 口（TH）系列",
    introSubName: "变压器<br />油面温控器",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000379&idx=1&sn=11bf937beaff5b7e3ccb61d4f51ff73e&chksm=7941a2104e362b06a76e6293972ba4132e9f9d03ca4b92670e2d3538a3721f1b00f236369863&scene=18&xtrack=1&key=f634041ead6d0331e495e8e4b6a1425cd0a0bb65b519f0e1ebfa3abf01d7fbd5d4e6dff93faf47267f88353cf68b25ab9a6cb20a63e0b3c19d0ee44376dc39b23e857b4cfea5b8cd48e1fa10242e3f4f&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=Ab%2FK9Bes3KIAK31MYwpssPk%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/BWR-04.jpg"),
    introName: "BWR - 04 口（TH）系列",
    introSubName: "变压器<br />绕组温控器",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000380&idx=2&sn=4bb7bc5372c63701b58c41c492aa8050&chksm=7941a2174e362b0133497ee10955ea3ac0e9d45b86dde687126f61ea4f050d95d215c1d4538e&scene=18&xtrack=1&key=5dab17bee8c24fcee1b5e8a326ed8fb895f4788b6a1a2868a978ede7fbfb26dead823602a7e9d4c34e9bb58e7664d2a4d0a00304754f615da8ce4e60b878b5bb88cec69256e18f3ac363377cd2420b7f&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=AXtqBroqnBQKYq8dHQK9VR4%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/BWY-804.jpg"),
    introName: "BWY -804 口（TH）系列",
    introSubName: "变压器<br />油面温控器",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000379&idx=2&sn=0062a8a2498fdbfd20926a916b39ed10&chksm=7941a2104e362b062729f2b91d90f5ca52e294f2e3d0ef0a18342994c32da70a225a45ceee48&scene=18&xtrack=1&key=e7e5f1c3668833f95501e22ba68393000551645d65d29844c60ed147e19e9af2f4828866e515a54f65875e99fbe08eeb7af827103b2675e0c7fc52ae7895c9d25935b4ef3efc55693b6cfb9114167750&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=ATmSRc3KTXNnRqECMSC0Re8%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  },
  {
    imgPath: require("@/assets/productions/BYZF.jpg"),
    introName: "BYZF-YA（TH）",
    introSubName: "变压器<br />油位计",
    link:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000376&idx=1&sn=bdda6ee424335ee6fd7474633aa049f3&chksm=7941a2134e362b0515592e3e92f224c35fe8cffd5e3a440b9f5b64274499987d7d7faafedad9&scene=18&xtrack=1&key=f634041ead6d0331dfb2e16af7575d458646caacf807bfb963fad29332dbb2438748f1ea95e82c3df32885804fcbddcbd9668ecf6d39365bfa646c86e802746c690d243bdc9fac7a30efc6003ec7647e&ascene=1&uin=NjkyMzAzMjQx&devicetype=Windows+10&version=62080085&lang=zh_CN&exportkey=AeA17Iq0ULM6%2FT2o1%2FGm0Yg%3D&pass_ticket=7JHdAFHkW%2FgJshAeAzkCF%2BqxchCigKGsi1MJXieJpzMLOp1X1wAhW9TaYokPGthh"
  }
];

/**
 * 最后修改时间 2020年3月31日08:23:16
 * 商务合作信息
 */
let coo = {
  title: "大连世有电力科技有限公司(原大连市金州仪器仪表厂)",
  arr: [
    {
      title: "地 址",
      content: "大连市金州区拥政街道胜利路947号"
    },
    {
      title: "销售热线1",
      content: "+86 (0) 411-87804698"
    },
    {
      title: "销售热线2",
      content: "+86 (0) 411-87869878"
    },
    {
      title: "售后服务",
      content: "+86 (0) 411-87868755"
    },
    {
      title: "传 真",
      content: "+86 (0) 411-87805542"
    },
    {
      title: "咨询热线1",
      content: "8008909651"
    },
    {
      title: "咨询热线2",
      content: "4008114698"
    },
    {
      title: "邮 编",
      content: "116100"
    },
    {
      title: "邮 箱",
      content: "syxsb@sykj.biz"
    },
    {
      title: "网 址",
      content: "www.sykj.biz"
    }
  ]
};

/**
 * 最后修改时间 2020年3月31日08:23:31
 * 招聘信息
 */
let conn = {
  title: "加入我们",
  arr: [
    {
      title: "招聘热线",
      content: "+86(0) 411-87804698/87869878"
    },
    {
      title: "地址",
      content: "大连市金州区拥政街道胜利路947号"
    }
  ]
};

let job = {
  title: "招聘职位",
  arr: [
    {
      title: "本科及以上",
      content: "编程方向技术人员"
    },
    {
      title: "本科及以上",
      content: "制图方向技术人员"
    },
    {
      title: "本科及以上",
      content: "电路设计方向技术人员"
    },
    {
      title: "专科及以上",
      content: "质检员"
    },
    {
      title: "专科及以上",
      content: "销售人员"
    },
    {
      title: "专科及以上",
      content: "品质管理"
    },
    {
      title: "专科及以上",
      content: "文员"
    }
  ]
};

/**
 * 最后修改时间 2020年3月31日08:24:11
 * 成功案例
 */
let projects_zn = [
  //智能产品
  {
    path: require("@/assets/project/case0-jpg.jpg"),
    title: "辽宁虎石台“智慧物联网”试点项目"
  },
  {
    path: require("@/assets/project/case50-jpg.jpg"),
    title: "辽宁虎石台“智慧物联网”试点项目"
  },
  {
    path: require("@/assets/project/case51-jpg.jpg"),
    title: "辽宁虎石台“智慧物联网”试点项目"
  },
  {
    path: require("@/assets/project/case1-jpg.jpg"),
    title: "吉尔吉斯斯坦比什凯克电厂"
  },
  {
    path: require("@/assets/project/case2-jpg.jpg"),
    title: "印度国家电网"
  },
  {
    path: require("@/assets/project/case3-jpg.jpg"),
    title: "新疆电力公司阿克苏 750KV "
  },
  {
    path: require("@/assets/project/case4-jpg.jpg"),
    title: "新疆电力公司烟墩 750KV "
  },
  {
    path: require("@/assets/project/case5-jpg.jpg"),
    title: "沈阳沙岭 500 千伏变电站"
  },
  {
    path: require("@/assets/project/case6-jpg.jpg"),
    title: "国网±800KV 伊克昭换流站"
  },
  {
    path: require("@/assets/project/case7-jpg.jpg"),
    title: "平齐线-开通220千伏牵引所铁路项目"
  },
  {
    path: require("@/assets/project/case8-jpg.jpg"),
    title: "南疆铁路"
  },
  {
    path: require("@/assets/project/case9-jpg.jpg"),
    title: "成渝铁路"
  },
  {
    path: require("@/assets/project/case10-jpg.jpg"),
    title: "兰新二线"
  },
  {
    path: require("@/assets/project/case11-jpg.jpg"),
    title: "宝兰线牵引变"
  },
  {
    path: require("@/assets/project/case12-jpg.jpg"),
    title: "中宁东牵引变"
  },
  {
    path: require("@/assets/project/case13-jpg.jpg"),
    title: "湖南电力公司"
  },
  {
    path: require("@/assets/project/case14-jpg.jpg"),
    title: "秦皇岛变电站"
  },
  {
    path: require("@/assets/project/case15-jpg.jpg"),
    title: "唐山变电站"
  },
  {
    path: require("@/assets/project/case16-jpg.jpg"),
    title: "国网冀北栾庄 220kV 变电站"
  },
  {
    path: require("@/assets/project/case17-jpg.jpg"),
    title: "三里庙 220kV 变电站"
  },
  {
    path: require("@/assets/project/case18-jpg.jpg"),
    title: "仿山 220kV 变电站"
  },
  {
    path: require("@/assets/project/case19-jpg.jpg"),
    title: "曹城 220kV 变电站"
  },
  {
    path: require("@/assets/project/case20-jpg.jpg"),
    title: "新疆巴州天鹅湖一号主变电站"
  },
  {
    path: require("@/assets/project/case21-jpg.jpg"),
    title: "新疆巴州供电公司金沙"
  },
  {
    path: require("@/assets/project/case22-jpg.jpg"),
    title: "保定天威保变电气股份有限公司"
  },
  {
    path: require("@/assets/project/case28-jpg.jpg"),
    title: "唐山曹妃甸变电站"
  },
  {
    path: require("@/assets/project/case35-jpg.jpg"),
    title: "辽宁省海城王石500KV变电站"
  },
  {
    path: require("@/assets/project/case36-jpg.jpg"),
    title: "辽宁省海城王石500KV变电站"
  },
  {
    path: require("@/assets/project/case37-jpg.jpg"),
    title: "锦州500kV利州变电站"
  },
  {
    path: require("@/assets/project/case38-jpg.jpg"),
    title: "连镇横山牵引变电所"
  },
  {
    path: require("@/assets/project/case45-jpg.jpg"),
    title: "烟墩750KV局放测试现场"
  },
  {
    path: require("@/assets/project/case46-jpg.jpg"),
    title: "库车750KV变电站电抗器检测"
  },
  {
    path: require("@/assets/project/case47-jpg.jpg"),
    title: "哈密750kv变电站土哈二线B相电抗器检测"
  },
  {
    path: require("@/assets/project/case48-jpg.jpg"),
    title: "哈密750kv变电站土哈二线A相电抗器检测"
  },
	{
		path: require("@/assets/project/case53-jpg.jpg"),
    title: "克拉玛依信息园220KV变电站"
	},{
		path: require("@/assets/project/case54-jpg.jpg"),
		title: "沈阳沈东500KV变电站"
	},{
		path: require("@/assets/project/case55-jpg.jpg"),
		title: "新疆若羌变电站"
	}
];

let projects_gq = [
  //光纤产品
  {
    path: require("@/assets/project/case49-jpg.jpg"),
    title: "辽宁虎石台“智慧物联网”试点项目"
  },
  {
    path: require("@/assets/project/case23-jpg.jpg"),
    title: "陕西地电周至"
  },
  {
    path: require("@/assets/project/case24-jpg.jpg"),
    title: "斗金山 220kV 变电站"
  },
  {
    path: require("@/assets/project/case25-jpg.jpg"),
    title: "连镇铁路"
  },
  {
    path: require("@/assets/project/case26-jpg.jpg"),
    title: "库格铁路"
  },
  {
    path: require("@/assets/project/case27-jpg.jpg"),
    title: "唐山曹妃甸变电站"
  }
];

let projects_wk = [
  //温控器
  {
    path: require("@/assets/project/case41-jpg.jpg"),
    title: "舟山±800kV 现场运行图"
  },
  {
    path: require("@/assets/project/case42-jpg.jpg"),
    title: "舟山±800kV 现场运行图"
  },
  {
    path: require("@/assets/project/case43-jpg.jpg"),
    title: "兰新线高铁项目现场运行图"
  },
  {
    path: require("@/assets/project/case44-jpg.jpg"),
    title: "兰新线高铁项目现场运行图"
  },
  {
    path: require("@/assets/project/case31-jpg.jpg"),
    title: "印度国家电网现场运行图"
  },
  {
    path: require("@/assets/project/case40-jpg.jpg"),
    title: "印度国家电网现场运行图"
  },
  {
    path: require("@/assets/project/case39-jpg.jpg"),
    title: "晋东南1000KV油位计"
  },
  {
    path: require("@/assets/project/case32-jpg.jpg"),
    title: "北京轨道交通新机场线一期工程项目现场运行图"
  },
  {
    path: require("@/assets/project/case33-jpg.jpg"),
    title: "特变电工沈阳变压器集团有限公司现场运行图"
  },
  {
    path: require("@/assets/project/case34-jpg.jpg"),
    title: "喀什750KV现场运行图"
  },{
		path: require("@/assets/project/case52-jpg.jpg"),
		title: "1000KV特高压淮南站"
	}
];

/*



*/

/**
 * 最后修改时间 2020年3月31日08:25:18
 * 新闻中心
 *
 */
let news = [
	// {
	// 	time: "2020/5/10",
 //    title: "世有科技董事长王世有带领部分员工向所有伟大的母亲致敬!!! ",
 //    path: require("@/assets/news/2020_3_29.jpg"),
 //    wechat: "https://mp.weixin.qq.com/s/bqJqyZz5iy0VpDhmfWBEXA"
	// },
	{
		time: "2020/3/29",
    title: "北美红栎26-28一对姊妹花嫁入豪门大院",
    path: require("@/assets/news/2020_3_29.jpg"),
    wechat: "https://v.douyin.com/vMGaAa/"
	},
  {
    time: "2020/1/24",
    title: "世有科技新春祝福短片 ",
    path: require("@/assets/news/2020_1_24.jpg"),
    wechat: "https://mp.weixin.qq.com/s/EzqNldskXM9CidynicMxnQ"
  },
  {
    time: "2019/11/7",
    title: "世有科技董事长王世有带领全体员工韶山、湘西红色之旅（张家界）",
    path: require("@/assets/news/2019_11_7.jpg"),
    wechat: "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000389&idx=1&sn=3ce11b90c597aa88535ea6cb4e6df302&scene=19#wechat_redirect"
  },
  {
    time: "2019/11/6",
    title: "世有科技董事长王世有带领全体员工韶山、湘西红色之旅",
    path: require("@/assets/news/2019_11_6.jpg"),
    wechat: "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000389&idx=1&sn=3ce11b90c597aa88535ea6cb4e6df302&scene=19#wechat_redirect"
  },
  {
    time: "2019/10/1",
    title: "世有科技董事长王世有带领全体员工庆祝祖国70华诞",
    path: require("@/assets/news/2019_10_1.jpg"),
    wechat: "https://mp.weixin.qq.com/s/wShZgIWTuNQyTEVrKd-brA"
  },
  {
    time: "2018/8/11",
    title: "参观关向应纪念馆，向先烈致敬！",
    path: require("@/assets/news/2018_8_11.jpg"),
    wechat:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=2247483901&idx=3&sn=4cd9dabb245365cca2ffd5bd54c4b544&scene=19#wechat_redirect"
  },
  {
    time: "2018/3/8",
    title: "世有科技“三八妇女节”活动 东沟温泉一日游",
    path: require("@/assets/news/2018_3_8.jpg"),
    wechat:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000104&idx=1&sn=d8c6057eff9c8c84844c42cb7d137807&scene=19#wechat_redirect"
  },
  {
    time: "2018/8/31",
    title: "世有科技油色谱 吉尔吉斯斯坦比什凯克电厂运行现场",
    path: require("@/assets/news/2018_8_31.jpg"),
    wechat:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000222&idx=1&sn=b5f5139f5deecb518528012be571afc8&scene=19#wechat_redirect"
  },
  {
    time: "2017/4/5",
    title: "世有科技荣获创新创业大赛大连赛区成长组二等奖",
    path: require("@/assets/news/2017_4_5.jpg"),
    wechat:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000016&idx=1&sn=6ba5a93c5950010f7b1eac018ce3b2bd&scene=19#wechat_redirect"
  },
  {
    time: "2016/5/14",
    title: "第十四届大连国际徒步大会 世有科技全员参加",
    path: require("@/assets/news/2016_5_14.jpg"),
    wechat:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000088&idx=1&sn=ffdfdd5c267899cf76c1d975dde6ca37&scene=19#wechat_redirect"
  },
  {
    time: "2013/2/20",
    title: "印度国家电网Shree Kumar一行莅临我公司",
    path: require("@/assets/news/2013_2_20.jpg"),
    wechat:
      "https://mp.weixin.qq.com/s?__biz=MzUxNDc2NzEwOA==&mid=100000011&idx=1&sn=62f5dbd5df9403bc650dbc996712ac28&scene=19#wechat_redirect"
  }
];

export { pros, coo, conn, job, projects_zn, projects_gq, projects_wk, news };
